import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  getOrganizationHolidays,
  postOrganizationHolidays,
  deleteOrganizationData,
  getLeaveYear,
} from "./leaveService";
import TosterService from "../../../Services/Toster-Service/TosterService";
import { TostMsg } from "../../../App";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import LeaveManagerReport from "./CommonComponents/LeaveManagerReport";
import LeaveNavBarItems from "./CommonComponents/LeaveNavBarItems";
import moment from "moment";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);
const defaultImage = "/images/event_dummy.jpg";

function OrganizationLeave() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const toster = useContext(TostMsg);
  const [organizationData, setOrganizationData] = useState([]);
  const [orgLeaveEditId, setOrgLeaveId] = useState(0);
  const [orgLeaveDeleteId, setOrgLeaveDeleteId] = useState(0);
  const [Isloading, setIsloading] = useState(false);
  const [selectedYear, setSelectedYear] = useState("");
  const [leaveYears, setLeaveYear] = useState([]);
  const [visibleAddOrgLeave, setVisibleAddOrgLeave] = useState(false);
  const [popupHeaderText, setPopupHeaderText] = useState("");
  const [showContent, setSeleteContent] = useState([]);
  const [updateOrg, setUpdateOrg] = useState(false);
  const currentDate = new Date();
  const isYearCurrent = currentDate.getFullYear();
  const [noData, setNoData] = useState([]);
  const [holidayType, setHolidayType] = useState(null);

  useEffect(() => {
    GetMasterSystemAlertList("Org_LeaveUnavailable", 2);
    window.scrollTo(0, 0);
    GetLeaveYears();
    PostHolidayMaster();
    permissionAccouncementList();
  }, []);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Holiday.Manage") {
        setUpdateOrg(true);
      }
    });
  };

  const setFastivalName = (event) => {
    const selectedFestivalId = event.value;
    const selectedFestivalName = event.originalEvent.target.innerText;
    orgLeaveForm.setFieldValue("HolidayMasterId", selectedFestivalId);
    orgLeaveForm.setFieldValue("leaveDetail", selectedFestivalName);
  };

  const handleImageError = useCallback((event) => {
    if (!event.target.dataset.fallbackApplied) {
      event.target.src = defaultImage;
      event.target.dataset.fallbackApplied = "true";
    }
  }, []);

  const updateOrgLeaveValidation = Yup.object().shape({
    leaveDetail: Yup.string().required("Festival name is required"),
    leaveDescription: Yup.string().required("Description is required"),
    leaveDate: Yup.string().required("Leave date is required"),
    HolidayMasterId: Yup.string().required("Festival type is required"),
  });

  const orgLeaveForm = useFormik({
    initialValues: {
      leaveDetail: "",
      leaveDescription: "",
      leaveDate: "",
      HolidayMasterId: "",
    },
    validationSchema: updateOrgLeaveValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      let LeaveDays = new Date(data?.leaveDate);
      let LeaveDaysNames = LeaveDays.getDay();
      let daysNames = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      const body = {
        Id: orgLeaveEditId ?? 0,
        OrgId: userDetails?.OrgId,
        BranchId: userDetails?.BranchId,
        LeaveDetail: data?.leaveDetail,
        LeaveDescription: data?.leaveDescription,
        LeaveDate: data?.leaveDate,
        LeaveDay: daysNames[LeaveDaysNames],
        HolidayMasterId: data?.HolidayMasterId,
      };
      try {
        await postOrganizationHolidays(body);
        getOrganizationDataList();
        GetLeaveYears();
        handalClosePopup();
        if (orgLeaveEditId) {
          GetMasterSystemAlertList("Update_Organization_Leave", 0);
        } else {
          GetMasterSystemAlertList("Add_Organization_Leave", 0);
        }
        setIsloading(false);
      } catch (err) {
        toster.current.error(ERROR_LIST.DefaultError);
        setIsloading(false);
      } finally {
        setIsloading(false);
      }
    },
  });

  const PostHolidayMaster = async () => {
    let params = {
      organisationId: userDetails?.OrgId,
      masterType: "HolidayMaster",
    };
    try {
      let response = await GetMasterTypeData(params);
      setHolidayType(response?.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  };

  const handalClosePopup = () => {
    setVisibleAddOrgLeave(false);
    setOrgLeaveId(0);
    orgLeaveForm.resetForm();
  };

  async function getOrganizationDataList() {
    setIsloading(true);
    const param = {
      OrgId: userDetails?.OrgId,
      BranchId: userDetails?.BranchId,
      Year: selectedYear || moment(currentDate).format("L")?.slice(-4),
    };
    try {
      const data = await getOrganizationHolidays(param);
      let OrganizationDetails = await data;
      setOrganizationData(OrganizationDetails?.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  async function editOrgLeave(orgLeaveDetails) {
    setOrgLeaveId(orgLeaveDetails?.Id);
    setVisibleAddOrgLeave(true);
    
    const editOrgData = {
      leaveDetail: orgLeaveDetails?.LeaveDetail,
      leaveDescription: orgLeaveDetails?.LeaveDescription,
      leaveDate: orgLeaveDetails?.LeaveDate
        ? moment(orgLeaveDetails?.LeaveDate, "MM/DD/YYYY hh:mm:ss A").format("YYYY-MM-DDTHH:mm:ss").split("T")[0]
         : null,
      HolidayMasterId: orgLeaveDetails?.HolidayMasterId,
    };
    orgLeaveForm.setValues(editOrgData);
  }

  async function deleteOrgLeaveDetails() {
    if (orgLeaveDeleteId) {
      let params = {
        id: orgLeaveDeleteId,
      };
      setIsloading(true);
      try {
        await deleteOrganizationData(params);
        getOrganizationDataList();
        GetLeaveYears();
        setSelectedYear("");
        GetMasterSystemAlertList("Deleted_Organization_Leave", 0);
        setIsloading(false);
      } catch (err) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  async function GetLeaveYears() {
    let params = {
      OrgId: userDetails?.OrgId,
    };
    try {
      let LeaveYearDetails = await getLeaveYear(params);
      setLeaveYear(LeaveYearDetails?.Data);
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setIsloading(false);
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }, []);

  useEffect(() => {
    if (leaveYears?.length > 0 && !selectedYear) {
      const currentYear = new Date().getFullYear();
      const currentYearObj = leaveYears?.find(
        (item) => item.LeaveYear === currentYear
      );
      setSelectedYear(currentYearObj?.LeaveYear);
    }
  }, [organizationData, leaveYears]);

  useEffect(() => {
    if (selectedYear) {
      getOrganizationDataList();
    }
  }, [selectedYear, isYearCurrent]);

  const employeeOptionTemplate = useCallback(
    (option) => {
      return (
        <div className="flex align-items-center gap-2">
          <img
            alt={option?.Name}
            src={option?.Logo || defaultImage}
            onError={handleImageError}
            width="32"
            style={{ opacity: "1" }}
          />
          <span>{option.Name}</span>
        </div>
      );
    },
    [handleImageError]
  );

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      <div className="container-fluid position-relation">
        <div className="row g-3">
          <div className="form-head mb-3">
            <div className="row">
              <div className="col-lg-5">
                <div className="d-flex align-items-center">
                  <div>
                    <h2 className="font-w600 mb-0">Organization Leave</h2>
                    {/* <p className="text-light">Lorem ipsum dolor sit amet</p> */}
                  </div>
                  <div
                    className="org-cate"
                    style={{ marginRight: "5px", marginLeft: "3px" }}
                  >
                    <Dropdown
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(e.value)}
                      options={leaveYears}
                      optionLabel="LeaveYear"
                      optionValue="LeaveYear"
                      placeholder="Select a year"
                      checkmark={true}
                      highlightOnSelect={false}
                    />
                  </div>
                  {updateOrg && (
                    <div>
                      {isYearCurrent <= selectedYear && (
                        <div className="org-add">
                          <div className="ms-2" style={{ cursor: "pointer" }} data-bs-toggle="modal"
                            data-bs-target="#org-leave"
                            title="Add Holiday"
                            onClick={() => {
                              setVisibleAddOrgLeave(true);
                              setPopupHeaderText("Add");
                            }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16"><path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path></svg>
                          </div>
                         
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-7">
                <LeaveNavBarItems />
              </div>
            </div>
          </div>
          <div className="col-xl-8">
            {organizationData?.OrgLeaveGroups?.map((orgLeave, index) => {
              const sortedOrgLeaveGroups = orgLeave?.OrgLeaveList.sort(
                (a, b) => {
                  return new Date(a.LeaveDate) - new Date(b.LeaveDate);
                }
              );
              return (
                <div
                  className="org-leave-card tile-grid tile-grid-v1"
                  key={index}
                >
                  <span className="fes-span">{orgLeave?.MonthName}</span>
                  {sortedOrgLeaveGroups?.map((orgLeaveDetails, index) => {
                    const givenLeaveDate = new Date(orgLeaveDetails?.LeaveDate);
                    const currentDate = new Date();
                    return (
                      <div className="holiday-cards bottom-card" key={index}>
                        {givenLeaveDate >= currentDate && (
                          <>
                            {updateOrg && (
                              <div className="org-edit">
                                {" "}
                                <button
                                  onClick={() => {
                                    editOrgLeave(orgLeaveDetails);
                                    setPopupHeaderText("Edit");
                                  }}
                                  title="Edit"
                                >
                                  <img src="images/org-img/leave/edit.svg" />
                                </button>
                                <button
                                  onClick={() => {
                                    setOrgLeaveDeleteId(orgLeaveDetails?.Id);
                                    GetMasterSystemAlertList(
                                      "Delete_Holidays",
                                      1
                                    );
                                  }}
                                  data-bs-toggle="modal"
                                  data-bs-target="#delete-ed"
                                  title="Delete"
                                >
                                  {/* <img src="images/org-img/leave/delete.svg" /> */}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    class="bi bi-trash"
                                    viewBox="0 0 16 16"
                                    color="red"
                                  >
                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                  </svg>
                                </button>
                              </div>
                            )}
                          </>
                        )}
                        <div className="card-body">
                          <div className="row org-leavelist g-2">
                            <div className="div">
                              <div className="h-avatar is-medium">
                                <img
                                  className="avatar"
                                  src={
                                    orgLeaveDetails?.ImagePath || defaultImage
                                  }
                                  onError={handleImageError}
                                  width="32"
                                  style={{ opacity: "1" }}
                                  alt=""
                                  data-user-popover="25"
                                  data-target="webuiPopover6"
                                />
                              </div>
                            </div>
                            <div className="div">
                              <div className="media-body px-0">
                                <h6 className="holiday-title">
                                  <a className="text-black">
                                    {orgLeaveDetails?.LeaveDetail}
                                  </a>
                                </h6>
                                <span className="holiday-des">
                                  {orgLeaveDetails?.LeaveDescription}
                                </span>
                              </div>
                            </div>
                            <div className="div">
                              <div className="media-body px-0 text-right">
                                <h2 className="mt-0 mb-0 fss-17 lighth2">
                                  {/* href="event.html" */}
                                  <a className="">
                                    {moment(orgLeaveDetails?.LeaveDate)?.format(
                                      "MMMM Do YYYY"
                                    )}
                                  </a>
                                </h2>
                                {/* <span className="mt-0 mb-3 datecol">Date</span> */}
                              </div>
                            </div>
                            <div className="div">
                              <div className="media-body px-0 text-right">
                                <h2 className="mt-0 mb-0 fss-17 lighth2">
                                  {/* href="event.html" */}
                                  <a className="">
                                    {orgLeaveDetails?.LeaveDay}
                                  </a>
                                </h2>
                                {/* <span className="mt-0 mb-3 datecol">Day</span> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
            {organizationData?.OrgLeaveGroups?.length === 0 ||
              (!organizationData?.OrgLeaveGroups && (
                <div className="notfound">
                  <img src="/images/no-data-found/no_holiday.png" />
                  <p>{noData}</p>
                </div>
              ))}
            {organizationData?.OrgLeaveGroups?.length == 0 && (
              <div className="notfound">
                <img src="/images/no-data-found/no_holiday.png" />
                <p>{noData}</p>
              </div>
            )}
          </div>
          <div className="col-xl-4">
            <div className="row sidecarddd">
              <div className="col-xl-12">
                <LeaveManagerReport />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        visible={visibleAddOrgLeave}
        style={{ width: "40vw" }}
        onHide={() => {
          if (!visibleAddOrgLeave) return;
          setVisibleAddOrgLeave(false);
          orgLeaveForm.resetForm();
        }}
      >
        <div
          className="modal-dialog modal-dialog-centered m-auto "
          role="document"
        >
          <div className="modal-content add-holiday">
            <img src="/images/org-img//leave/holiday.png" />
            <div className="modal-header pb-2">
              <h5 className="modal-title m-auto">
                {popupHeaderText} Organization Leaves
              </h5>
            </div>
            <form onSubmit={orgLeaveForm.handleSubmit}>
              <div className="modal-body text-center row">
                <div className="form-group text-left col-md-6">
                  <label className="">Festival Type</label>
                  <Dropdown
                    options={holidayType}
                    optionLabel="Name"
                    optionValue="Id"
                    placeholder="Select Festival"
                    checkmark={true}
                    highlightOnSelect={false}
                    className={
                      orgLeaveForm.errors.HolidayMasterId &&
                      orgLeaveForm.touched.HolidayMasterId
                        ? "is-invalid form-control wide"
                        : ""
                    }
                    itemTemplate={employeeOptionTemplate}
                    value={orgLeaveForm.values.HolidayMasterId}
                    onChange={(e) => setFastivalName(e)}
                  />
                  <div className="invalid-feedback">
                    {orgLeaveForm.errors.HolidayMasterId &&
                    orgLeaveForm.touched.HolidayMasterId
                      ? orgLeaveForm.errors.HolidayMasterId
                      : null}
                  </div>
                </div>
                <div className="form-group text-left col-md-6">
                  <label className="">Festival Name</label>
                  <input
                    type="text"
                    name="leaveDetail"
                    className={
                      "form-control" +
                      (orgLeaveForm.errors.leaveDetail &&
                      orgLeaveForm.touched.leaveDetail
                        ? " is-invalid"
                        : "")
                    }
                    onChange={orgLeaveForm.handleChange}
                    value={orgLeaveForm.values.leaveDetail}
                    placeholder="Festival Name"
                  />

                  <div className="invalid-feedback">
                    {orgLeaveForm.errors.leaveDetail &&
                    orgLeaveForm.touched.leaveDetail
                      ? orgLeaveForm.errors.leaveDetail
                      : null}
                  </div>
                </div>
                <div className="form-group text-left col-md-12">
                  <label className="">
                    Festival Description{" "}
                    <i
                      style={{
                        color: "blue",
                      }}
                    >
                      (Only 100 characters are allowed.)
                    </i>
                  </label>
                  <textarea
                    maxLength="100"
                    type="text"
                    name="leaveDescription"
                    className={
                      "form-control" +
                      (orgLeaveForm.errors.leaveDescription &&
                      orgLeaveForm.touched.leaveDescription
                        ? " is-invalid"
                        : "")
                    }
                    onChange={orgLeaveForm.handleChange}
                    value={orgLeaveForm.values.leaveDescription}
                    placeholder="Festival Description"
                  />

                  <div className="invalid-feedback">
                    {orgLeaveForm.errors.leaveDescription &&
                    orgLeaveForm.touched.leaveDescription
                      ? orgLeaveForm.errors.leaveDescription
                      : null}
                  </div>
                </div>
                <div className="form-group text-left col-md-12">
                  <label className="">Date</label>
                  <input
                    type="date"
                    name="leaveDate"
                    onClick={(e) =>
                      e.target.showPicker && e.target.showPicker()
                    }
                    className={
                      "form-control" +
                      (orgLeaveForm.errors.leaveDate &&
                      orgLeaveForm.touched.leaveDate
                        ? " is-invalid"
                        : "")
                    }
                    onChange={orgLeaveForm.handleChange}
                    value={orgLeaveForm.values.leaveDate}
                    placeholder="Date"
                    min={
                      new Date(new Date().getFullYear(), 0, 2)
                        .toISOString()
                        .split("T")[0]
                    }
                  />

                  <div className="invalid-feedback">
                    {orgLeaveForm.errors.leaveDate &&
                    orgLeaveForm.touched.leaveDate
                      ? orgLeaveForm.errors.leaveDate
                      : null}
                  </div>
                </div>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                  onClick={handalClosePopup}
                >
                  Cancel
                </button>
                <button type="submit" className="savebtn-click modal-save-btn">
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
      <div className="modal fade" id="delete-ed">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              {/* <strong className="modal-title">Are you sure?</strong>
              <p>{showContent}</p> */}
              <strong className="modal-title">{showContent}</strong>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
                onClick={() => setSeleteContent([])}
              >
                Close
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteOrgLeaveDetails()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <TosterService ref={toster} />
      {Isloading ? (
        <Suspense >
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}

export default OrganizationLeave;
